export default __webpack_public_path__ + "static/qr-4db0746d05380e23c40c416f2fade72a.svg";